import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AreasActions } from './actions/areas.actions';
import { AreasMainComponent } from './components/areas-main/areas-main.component';


@NgModule( {
    imports: [
        CommonModule
    ],
    declarations: [ AreasMainComponent ],
    exports: [ AreasMainComponent ],
    providers: [ AreasActions ]
} )
export class AreasModule { }
